import React from 'react';
import styled, { css } from 'styled-components';
import { mobileMQ } from './media-utils';

export const PageWrapper = styled.div`
    margin: 0 0 124px;
    padding: 0 112px; // 80px + 32px
    box-sizing: border-box;

    @media screen and (max-width: 1200px) {
        padding: 0;
        margin-bottom: 32px;
    }
`;

export const NewPageWrapper = styled.div`
    margin: 0 0 124px;
    padding: 0 225px;
    /* box-sizing: border-box; */
    max-width: 752px;

    @media screen and (max-width: 1200px) {
        padding: 0;
        margin-bottom: 32px;
    }
`;

export const NewContentWrapper = styled.div`
    max-width: 640px;
    svg {
        width: 70%;
        display: block;
        margin: 1.5rem auto;
        ${mobileMQ(css`
            width: 75%;
        `)}
    }
`;

export const ContentWrapper = styled.div`
    max-width: 752px;
`;
